import React, { FC, useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { useParams } from 'react-router-dom';
import { api, endpoints } from '../../../api';
import { PdfViewerComponent } from '../../../components/PdfViewerComponent/PdfViewerComponent';
import { BlueLayout, PagesContainerUI, TabsContainer } from '../../../styles/styled';
import { ExpertiseType } from '../../ExpertisePage/types';
import { ExpertiseExpertListsType } from '../types';
import ExpertExpertiseToolbar from './ExpertExpertiseToolbar';
import ExpertMainInfo from './ExpertMainInfo';

const { TabPane } = Tabs;

type ExpertExpertiseListProps = {
  edit?: boolean;
};

export const ExpertExpertiseList: FC<ExpertExpertiseListProps> = ({ edit }) => {
  const [currentExpertiseState, setCurrentExpertise] = useState<ExpertiseType | undefined>();
  const [currentElState, setCurrentEl] = useState<ExpertiseExpertListsType>();
  const [openBookState, setOpenBook] = useState<string | null>(null);

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const currentExpertiseResponse = await api.get<ExpertiseType>(endpoints.getExpertiseById(id));

          setCurrentExpertise(currentExpertiseResponse.data);

          const currentEl = await api.get<ExpertiseExpertListsType>(
            endpoints.getExpertiseListById(currentExpertiseResponse.data?.expertise_list?.id || 0),
          );

          setCurrentEl(currentEl.data);
        } catch (err) {}
      })();
    }
  }, [id]);

  useEffect(() => {
    if (openBookState) {
      document.body.style.overflow = 'hidden';
      window.scrollTo(0, 0);
    } else document.body.style.overflow = 'auto';
  }, [openBookState]);

  return (
    <PagesContainerUI>
      {openBookState && <PdfViewerComponent closePdfViewer={() => setOpenBook(null)} bookLink={openBookState} />}

      <BlueLayout padding="35px 0 10px 0">{currentExpertiseState?.textbook.title}</BlueLayout>
      <TabsContainer white>
        <Tabs type="card" tabBarGutter={0}>
          <TabPane tab="Основные сведения" key="1">
            <ExpertMainInfo expertise={currentExpertiseState} />
          </TabPane>
          <TabPane tab="Экспертиза" key="2">
            <ExpertExpertiseToolbar
              setOpenBook={(value: string | null) => setOpenBook(value)}
              edit={edit}
              expertise_list={currentElState}
              expertise={currentExpertiseState}
            />
          </TabPane>
        </Tabs>
      </TabsContainer>
    </PagesContainerUI>
  );
};
